<template>
  <div class="questionnaire-question-content">

    <div v-if="audio==null || audio==''" class="questionnaire-question-question">
      Repérez les fautes et corrigez-les
    </div>
    <div v-else class="questionnaire-question-question">
      Repérez les fautes et corrigez-les
      <div class="questionnaire-question-image" @click.prevent="playSound()">
        <img src="@/assets/img/listen.png">
      </div>
    </div>

    <div id="actualSentence" class="questionnaire-question-sentence"></div>

    <div class="questionnaire-question-response">
      <div class="form-group">
        <Field id="wordResponse" autocapitalize="none" autocomplete="off" class="questionnaire-question-response-input" name="text" spellcheck="false" type="hidden" @change="changeOnField($event)"/>
        <ErrorMessage class="error-feedback" name="email"/>
        <span id="error-regex" class="text-danger"></span>
      </div>
    </div>
    <div v-if="audioCurrentTime !== '' && audioCurrentTime != null" class="questionnaire-question-question"><br/>Durée de l'audio : {{ audioCurrentTime }} / {{ audioDuration }} s</div>
  </div>
</template>

<script>
import {ErrorMessage, Field} from "vee-validate";
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "ExpressionChooseWordToChange",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    question: String,
    response: String,
    audio: String,
    regex: String,
    error: Boolean
  },
  data() {
    return {
      idElement: null,
      initialSentence: "",
      actualSentence: null,
      answer: null,
      domainId: this.$parent.domainId,
      indexQuestion: this.$parent.indexQuestion,
      audioDuration: '',
      audioCurrentTime: ''
    }
  },
  methods: {
    disableClick: function (time) {
      time = time * 1000
      var element = document.getElementById('questionContent');
      element.classList.add('questionnaire-question-disable');
      setTimeout(
          function () {
            element.classList.remove('questionnaire-question-disable');
          }, time
      )
    },
    playSound() {
      var audioInstance = new Audio(require('@/assets/sounds/' + this.audio))
      var _ = this;

      audioInstance.addEventListener('loadedmetadata', function () {
        audioInstance.setAttribute('data-time', audioInstance.duration);
        _.audioDuration = audioInstance.duration.toFixed(1);
      }, false);

      audioInstance.play().then(() => {
        this.disableClick(audioInstance.duration)
        this.$parent.remainingTime = this.$parent.remainingTime + Math.floor(audioInstance.duration)
        this.$parent.saveListen(this.$parent.listen)
      })

      audioInstance.addEventListener("timeupdate", function () {
        _.audioCurrentTime = (audioInstance.currentTime % 60).toFixed(1);
      }, false);

    },
    changeOnField: function (event) {

      document.getElementById('error-regex').innerHTML = '';

      document.getElementById(this.idElement).textContent = event.target.value;
      document.getElementById('wordResponse').value = '';
      document.getElementById('wordResponse').type = 'hidden';

      this.actualSentence = this.replaceSentence(" ", this.initialSentence)
      let html = document.getElementById('actualSentence').innerHTML

      this.answer = html.replace(/<\/?span[^>]*>/g, "")
      this.answer.replace("  ", " ")
      this.idElement = null
      this.$emit('update:error', false)

    },
    selectWord: function (event) {
      var word = event.target.textContent
      this.idElement = event.target.id
      document.getElementById('wordResponse').type = 'text';
      document.getElementById('wordResponse').value = word;
      document.getElementById("wordResponse").focus();
    },
    replaceSentence: function (split, sentence) {
      var reg = new RegExp('[' + split + ']');
      var words = sentence.split(reg);
      var wordsExclude = [];
      words.forEach((word, index) => {
        if (wordsExclude.indexOf(word.toLowerCase().trim()) == -1) {
          words[index] = '<span id="word' + index + '">' + word + '</span>';
        }
      });

      if (this.answer == undefined) {
        words.forEach((word, index) => {
          if (wordsExclude.indexOf(word.toLowerCase().trim()) == -1) {
            words[index] = '<span id="word' + index + '">' + word + '</span>';
          }
        })
      } else {
        var wordsAnswer = this.answer.split(reg)
        words.forEach((word, index) => {
          if (wordsExclude.indexOf(word.toLowerCase().trim()) == -1) {
            words[index] = '<span id="word' + index + '">' + wordsAnswer[index] + '</span>';
          }
        });
      }
      return words.join(split);
    },
    addSpan: function (sentence) {
      var reg = /word[0-9]?[0-9]?[0-9]/g
      var array = sentence.match(reg)
      array.forEach((word) => {
        document.getElementById(word).addEventListener("click", this.selectWord, false);
      });
    },
    init: function (answer) {
      this.actualSentence = (answer) ? answer : this.question;
      this.actualSentence = this.replaceSentence(' ', this.actualSentence);
      document.getElementById('actualSentence').innerHTML = this.actualSentence;
    }
  },
  mounted() {
    UserService.getUserTestQuestions(this.domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (this.indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) this.answer = arrayResponses[index]['answer']
          this.init(this.answer)
          document.getElementById('actualSentence').innerHTML = this.actualSentence;
          this.addSpan(this.actualSentence)

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
